var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEftPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    fill: "#FAE3D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0919 11H45.5C45.3412 11.8619 45.1824 12.7063 45.0236 13.5799H41.3654C40.6678 17.4002 39.9701 21.1972 39.2725 25H36.3857C37.0833 21.1913 37.7752 17.4002 38.4728 13.5915H31.5081C31.3039 14.6572 31.0997 15.7404 30.8842 16.8469H35.6597C35.4952 17.6972 35.3364 18.5183 35.1776 19.3627H30.4248C30.0788 21.2496 29.7328 23.119 29.3869 25H26.5C27.3678 20.3411 28.2242 15.688 29.0919 11Z",
    fill: "#E47418"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1809 13.5052C21.9819 14.5306 21.7887 15.5268 21.5838 16.5697H26.4077C26.2437 17.4145 26.0915 18.2243 25.9335 19.0574H21.1096C20.893 20.2052 20.6764 21.3296 20.454 22.4948H26.0915C25.9335 23.3396 25.7813 24.161 25.6232 25H17L19.6695 11H28C27.8361 11.839 27.678 12.6604 27.5141 13.511L22.1809 13.5052Z",
    fill: "#E47418"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5C16.9423 14.8427 16.8904 15.1643 16.8385 15.5H6C6.05191 15.1643 6.10383 14.8427 6.16151 14.5H17Z",
    fill: "#E47418"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5L9.16872 13H17.5C17.4476 13.1701 17.3953 13.3299 17.3429 13.5H9Z",
    fill: "#E47418"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11C17.9486 11.3378 17.8971 11.6622 17.84 12H12C12.0571 11.6622 12.1086 11.3311 12.16 11H18Z",
    fill: "#E47418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEftPreview);
export default __webpack_public_path__ + "static/media/EFTPreview.d585fc5e30daf870110ad71806d0c8d4.svg";
export { ForwardRef as ReactComponent };